export default __webpack_public_path__ + "7029b44c58a23c824bc44a045188f6cb.svg";